/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAward(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12 1.75a6.25 6.25 0 103.315 11.55.756.756 0 01.142-.092A6.25 6.25 0 0012 1.75zm4.595 12.492a7.75 7.75 0 10-9.188 0l-1.15 8.66a.75.75 0 001.129.741L12 20.875l4.614 2.768a.75.75 0 001.13-.742l-1.15-8.66zm-1.404.823A7.72 7.72 0 0112 15.75a7.72 7.72 0 01-3.19-.685l-.862 6.491 3.666-2.2a.75.75 0 01.772 0l3.666 2.2-.861-6.491z'
      />
    </svg>
  );
}

export default SvgAward;
